import React, { useEffect, useState } from "react";
import {
    colors,
    Container,
    Grid,
    Hidden,
    makeStyles,
    Paper,
    Typography,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { insh as inshst } from "../../../Context/InshSt";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { uri } from "../../../help/Api";
import toast from "react-hot-toast";
import SalesPermissions from "./SalesPermissions.js/SalesPermissions";
import BasicPermissions from "./BasicPermission";
import QutaionsPermission from "./SalesPermissions.js/QutaionsPermission";
import OrdersPermission from "./PurchasePermission/OrdersPermission";
import SafesPermission from "./SafesPermission/SafesPermission";
import AccountsPermission from "./AccountsPermission/AccountsPermission";
import OthersSettings from "./AccountsPermission/OtherPermission";
import AnnualSuscriptionAppBar from "../AnnualSuscription/AnnualSuscriptionAppBar";
import { prepateBasicPerms } from "../../../services/permissions-services";
import UsersPermForm from "./UsersPermForm";
import PurchasePermssion from "./PurchasePermission/PurchasePermssion";
import clsx from "clsx";
import { GroupSelectRest } from "../../Invs/BackEnd/POS/GroupSelectRest";
// import { useTranslation } from "react-i18next";
import {
    useStylesCAB,
    useStylesBA,
} from "../../../St/comps/UseStyle";
import { insh } from "../../../Context/InshData";
import { select_Types } from "./checksPermmision";
import IntermedateCon from "../../Accounts/BackEnd/IntermediateAcc/IntermedateCon";

const useStyles = makeStyles((theme) => ({
    root: {
        borderColor: "#ADD8E6",
        minHeight: "100%",
    },
    input: {
        display: "none",
    },
    imageLogo: {
        marginRight: 20,
        marginTop: 5,
        marginBottom: 10,
        textAlign: "center",
    },
    headerTitle: {
        backgroundColor: "#d6fcfe",
        textAlign: "center",
        fontSize: 20,
        width: "100%",
        fontWeight: "bold",
        marginBottom: "0.5rem"
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: "#ADD8E6",
        borderColor: "#ADD8E6",

    },

}));
export default function UsersPermission(props) {
    const { AutoOptions } = props;
    const { t } = useTranslation(["forms"]);
    const clasBA = useStylesBA();

    const clasCAB = useStylesCAB();

    const classes = useStyles();
    const [formsData, setFormsData] = useState({ user: AutoOptions?.Users[0], Form_id: 40002, isStart: false });

    const [object, setObject] = useState({});
    const [gData, setGData] = useState({ user: AutoOptions?.Users[0], Form_id: 40002, id: 1 });
    const [fetching, setFetching] = useState(false);

    const viewHandle = async (user_id, form_id) => {
        setObject({});
        setFetching(true);
        await axios
            .get(
                uri +
                `UserPermission/getWithUserTable?id=${user_id}
    &&f=${form_id}`
            )
            .then((res) => {
                // let data = res.data;
                setObject({
                    ...res.data?.perms,
                    No_Digit_Round: res.data?.system?.No_Digit_Round
                    , is_tab3_sub: res.data?.system?.is_tab3_sub,
                    Max_Item_Qty: res.data?.system?.Max_Item_Qty,
                    Max_Item_Total: res.data?.system?.Max_Item_Total,
                    prices_levels_type: res.data?.system?.prices_levels_type, ...res.data?.user
                });
                // console.log(" the data is", res.data);
                // setFetching(false);
            })
            .catch((err) => {
                setFetching(false);
                // console.log(err);
                toast.error(t("fetch-error"));
                // setData([]);
            });
    };

    useEffect(() => {
        if (formsData.isStart === false) {
            viewHandle(formsData.user.id, 40002);
            setFormsData({ ...formsData, isStart: true });
        }
    }, [formsData, setFormsData]);

    const his = useHistory();
    const back = () => {
        his.goBack();
    };
    const backHome = () => {
        his.push({ pathname: "/" });
    };
    const onChange = (e, { name, value }) => {
        if (name === "Disc_saleOnBills") {
            setObject({ ...object, Disc_saleOnItem: false, [name]: value })

        } else if (name === "Disc_saleOnItem") {
            setObject({ ...object, Disc_saleOnBills: false, [name]: value })
        }
        else if (name === "sale_no_less_than_minPrice") {
            if (value === true) {
                setObject({ ...object, sale_no_less_than_minPrice: 1 })
            } else {
                setObject({ ...object, sale_no_less_than_minPrice: 0 })
            }
        }
        else if (name === "use_price_without_vat") {
            if (value === true) {
                setObject({ ...object, use_price_without_vat: 1 })
            } else {
                setObject({ ...object, use_price_without_vat: 0 })
            }
        }
        else if (name === "Purch_out_goods") {
            if (value === true) {
                setObject({ ...object, Purch_out_goods: 1 })
            } else {
                setObject({ ...object, Purch_out_goods: 0 })
            }
        }
        else if (name === "use_barcode_reader") {
            if (value === true) {
                setObject({ ...object, use_barcode_reader: 1 })
            } else {
                setObject({ ...object, use_barcode_reader: 0 })
            }
        }
        else if (name === "return_same_invoice_date") {
            if (value === true) {
                setObject({ ...object, return_same_invoice_date: 1 })
            } else {
                setObject({ ...object, return_same_invoice_date: 0 })
            }
        }
        else if (name === "SalePointOnly") {
            if (value === true) {
                setObject({ ...object, SalePointOnly: 1 })
            } else {
                setObject({ ...object, SalePointOnly: 0 })
            }
        }
        else if (name === "used_shifts_transClose") {
            if (value === true) {
                setObject({ ...object, used_shifts_transClose: 1 })
            } else {
                setObject({ ...object, used_shifts_transClose: 0 })
            }
        }
        else if (name === "hide_item_data") {
            if (value === true) {
                setObject({ ...object, hide_item_data: 1 })
            } else {
                setObject({ ...object, hide_item_data: 0 })
            }
        }
        else if (name === "is_tab3_sub") {
            if (value === true) {
                setObject({ ...object, is_tab3_sub: 1 })
            } else {
                setObject({ ...object, is_tab3_sub: 0 })
            }
        }
        else if (name === "hide_item_info") {
            if (value === true) {
                setObject({ ...object, hide_item_info: 1 })
            } else {
                setObject({ ...object, hide_item_info: 0 })
            }
        }
        else {
            setObject({ ...object, [name]: value })
        }

    }
    const [selectColor, setSelectColor] = useState({ id: 0, color: colors.blue[300] });
    const onRowClick = (row) => {
        setFormsData({ ...formsData, Form_id: row.Form_id });
        setGData({ ...gData, Form_id: row.Form_id, id: row.id });
        setSelectColor({ ...row, color: colors.blue[300] });
        if (row.Form_id !== 1000) {
            viewHandle(formsData?.user?.id, row.Form_id);
        }
    };
    const [loading, setLoading] = useState(insh.LoadAndSucc);
    const [success, setSuccess] = useState(insh.LoadAndSucc);
    const addToBS = async () => {
        if (object?.allow_discount) {
            if ((object.apply_discount == 1 || object.apply_discount == 3) && parseFloat(object?.SaleDiscPers) <= 0) {
                alert(t("specify-discount-percent"));
            } else if ((object.apply_discount == 2 || object.apply_discount == 3) && parseFloat(object?.SaleDiscValue) <= 0) {
                alert(t("specify-discount-amount"));
            } else {
                try {
                    await addToBatabase();
                } catch (e) {
                    toast.error(t("update-failed"))
                    console.log(e);
                }
            }
        } else {
            try {
                await addToBatabase();
            } catch (e) {
                toast.error(t("update-failed"))
                console.log(e);
            }
        }
    }
    const buttonClassnameSave = clsx({
        [clasCAB.buttonSuccessCAB]: success?.save,
    });
    const timer = React.useRef();

    const ButtonLoading = (prop) => setLoading({ ...loading, [prop]: true });
    const ButtonSuccess = (prop, timr) => {
        timer.current = window.setTimeout(() => {
            setLoading({ ...loading, [prop]: false });
            setSuccess({ ...success, [prop]: true });
            if (prop != "save");
        }, timr);
    };

    const addToBatabase = () => {
        ButtonLoading("save");
        let pData = prepateBasicPerms(object);
        let _Data = {
            ...pData,
            user_id: formsData.user?.id,
            Form_id: formsData.Form_id,
        };
        axios
            .put(uri + "UserPermission", _Data)
            .then((res) => {
                toast.success("تمت عملية التعديل بنجاح");
                ButtonSuccess("save", 1000);
            })
            .catch((res) => {
                toast.error(" لم يتم عملية التعديل ");
                ButtonSuccess("false", 1000);
            });

    };

    const changeUserAutos = (prop, newValue) => {
        setGData({ ...gData, user: newValue });
        setFormsData({ ...formsData, user: newValue });
        viewHandle(newValue.id, formsData.Form_id);
    };
    return (
        <div className={classes.root}>
            <Grid container item xs={12}>
                <Typography size="small" className={classes.headerTitle}>
                    {t("صلاحيات المستخدمين")}
                </Typography>
            </Grid>
            <Container
                component={Paper}
                maxWidth={false}
                style={{
                    padding: "10px",
                    paddingBottom: "0px",
                    borderBottomColor: "#bdf9fd",
                    borderBottomWidth: "10px",
                    borderBottomStyle: "solid",
                }}
            >
                <Hidden smDown>
                    <GroupSelectRest
                        groups={[...select_Types]}
                        onRowClick={onRowClick}
                        isMain={true}
                        GroupColor={selectColor}
                        isPerm={true}
                    />
                </Hidden>
                <Hidden mdUp>
                    <GroupSelectRest
                        groups={[...select_Types]}
                        onRowClick={onRowClick}
                        isMain={true}
                        GroupColor={selectColor}
                        isPerm={false}
                    />
                </Hidden>

            </Container>
            {gData.id == 9 ?
                <>
                    <IntermedateCon
                        AutoOptionsB={AutoOptions}
                    />
                </>
                :

                <Typography component="div" style={{ direction: "rtl" }}>

                    <Container
                        component={Paper}
                        maxWidth={false}
                        style={{
                            padding: "10px",
                            paddingBottom: "0px",
                            borderBottomColor: "#bdf9fd",
                            borderBottomWidth: "10px",
                            borderBottomStyle: "solid",
                        }}
                    >
                        <UsersPermForm
                            {...{
                                AutoOptions, gData, changeUserAutos
                            }}
                        />
                    </Container>
                    <br />
                    <Container maxWidth={true} style={{ padding: "4px" }}>
                        {gData.id == 1 &&
                            <SalesPermissions
                                {...{
                                    onChange, object, AutoOptions,gData
                                }}
                            />}
                        {gData.id == 3 &&
                            <PurchasePermssion
                                {...{
                                    onChange, object
                                }}
                            />}
                        {gData.id == 4 &&
                            <BasicPermissions
                                {...{
                                    onChange, object
                                }}
                            />}

                        {gData.id == 5 &&
                            <QutaionsPermission
                                {...{
                                    onChange, object
                                }}
                            />}
                        {gData.id == 6 &&
                            <OrdersPermission
                                {...{
                                    onChange, object
                                }}
                            />}
                        {gData.id == 7 &&
                            <SafesPermission
                                {...{
                                    onChange, object, viewHandle, formsData, setFormsData
                                }}
                            />}
                        {gData.id == 8 &&
                            <AccountsPermission
                                {...{
                                    onChange, object, AutoOptions, viewHandle, formsData, setFormsData
                                }}
                            />}
                        {gData.id == 10 &&
                            <OthersSettings
                                {...{
                                    onChange, object, AutoOptions
                                }}
                            />}
                    </Container>
                    <AnnualSuscriptionAppBar {...{
                        buttonClassnameSave,
                        clasCAB,
                        addToBS,
                        loading,
                        clasBA,
                        backHome,
                        back,
                        prevent: false,
                        isPerm:true
                    }}
                    />
                </Typography>
            }
        </div>
    );
}
